import { selectAlertsByHierarchy, useAppSelector } from '@/store'
import { Alert } from '@/types/alerts'
import { useMemo } from 'react'

export const useCategoryAlerts = (clarityLensType: string) => {
  // Get all alerts for this clarity lens type
  const allAlerts = useAppSelector(
    selectAlertsByHierarchy({
      clarityLens: clarityLensType,
    })
  )

  const getCategoryAlertCount = useMemo(() => {
    return (categoryName: string) => {
      // Filter to include all alerts that belong to this category
      // This includes direct category alerts, item alerts, and tab alerts
      const categoryAlerts = allAlerts.filter(
        (alert: Alert) => alert.hierarchy.category === categoryName
      )

      return {
        total: categoryAlerts.length,
        unread: categoryAlerts.filter((alert: Alert) => !alert.isRead).length,
        alerts: categoryAlerts,
      }
    }
  }, [allAlerts])

  const getItemAlertCount = useMemo(() => {
    return (itemName: string) => {
      // Filter to include all alerts that belong to this item (subcategory or SKU)
      // Check category field (for 2-level hierarchies like Sales Lens)
      // Check subCategory field (for 3-level hierarchies like Spend Lens subcategories)
      // Check item field (for SKU items in both 2-level and 3-level hierarchies)
      const itemAlerts = allAlerts.filter(
        (alert: Alert) =>
          alert.hierarchy.category === itemName ||
          alert.hierarchy.subCategory === itemName ||
          alert.hierarchy.item === itemName
      )

      return {
        total: itemAlerts.length,
        unread: itemAlerts.filter((alert: Alert) => !alert.isRead).length,
        alerts: itemAlerts,
      }
    }
  }, [allAlerts])

  return {
    getCategoryAlertCount,
    getItemAlertCount,
  }
}
